package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SyndromeType(private val literal: String) : IEnumType {
	系统默认("系统默认"),
	机构所有("机构所有"),
	个人所有("个人所有");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "syndrome_type"}
	override fun getLiteral(): String {return literal}
}
